export const SALES_DASHBOARD_TAB_ORDER = ['calendar', 'media-plans', 'rate-cards', 'pipeline'] as const;

export type SalesDashboardTabKey = (typeof SALES_DASHBOARD_TAB_ORDER)[number];

export function isSalesDashboardTabKey(value: string | null | undefined): value is SalesDashboardTabKey {
  return !!value && (SALES_DASHBOARD_TAB_ORDER as readonly string[]).includes(value);
}

/** A Culture Genius chat draft to open in the builder (?draft=<id>). A plan deep link (?plan=) wins over it. */
export function mediaPlanChatDraftId(searchParams: Pick<URLSearchParams, 'get'>): string | null {
  return searchParams.get('plan') ? null : searchParams.get('draft') || null;
}

/** The media plan builder is open (?new=1, or a chat draft's ?draft=<id>). A plan deep link (?plan=) wins over it. */
export function isMediaPlanBuilderOpen(searchParams: Pick<URLSearchParams, 'get'>): boolean {
  return (searchParams.get('new') === '1' || !!searchParams.get('draft')) && !searchParams.get('plan');
}

/**
 * Calendar is the default. An entry deep link (?entry=) forces the calendar,
 * a plan or chat-draft deep link (?plan=, ?draft=) forces Media Plans, then a
 * known ?tab= wins; an open builder (?new=1) with no tab lands on Media Plans.
 */
export function resolveInitialSalesDashboardTab(
  searchParams: Pick<URLSearchParams, 'get'>,
): SalesDashboardTabKey {
  if (searchParams.get('entry')) return 'calendar';
  if (searchParams.get('plan') || searchParams.get('draft')) return 'media-plans';
  const tab = searchParams.get('tab');
  if (isSalesDashboardTabKey(tab)) return tab;
  return isMediaPlanBuilderOpen(searchParams) ? 'media-plans' : 'calendar';
}
